export const BIRDS_GROUP_LIST_VIEW = "/birds-groups"
export const BIRDS_GROUP_VIEW = `${BIRDS_GROUP_LIST_VIEW}/:birdGroupId`
export const NEW_BIRDS_GROUP_VIEW = BIRDS_GROUP_LIST_VIEW + "/new"
export const EDIT_BIRDS_GROUP_VIEW = BIRDS_GROUP_VIEW + "/edit"
